"use client";

import Mention from "@tiptap/extension-mention";
import { mentionSuggestionOptions } from "./suggestion-options";

const ProfileMentionExtension = Mention.extend({
	name: "profile-mention",
}).configure({
	renderHTML({ options, node }) {
		return [
			"a",
			// TODO (zeekhuge): The path information is hardcoded below. It shouldn't be like this
			{ href: node.attrs.id ? `/user/${node.attrs.id}` : `#`, class: "content-mention" },
			`${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`,
		];
	},
	suggestion: mentionSuggestionOptions,
});

export default ProfileMentionExtension;
